﻿package com.mgacreative.hotelru

import org.koin.core.module.Module
import org.koin.dsl.module
import com.mgacreative.hotelru.shared.ui.designsystem.di.getCommonAppModule
import com.mgacreative.hotelru.domain.di.getDomainModule
import com.mgacreative.hotelru.feature.admin.di.getAdminFeatureModule
import com.mgacreative.hotelru.feature.hotel.di.getHotelFeatureModule
import com.mgacreative.hotelru.feature.reservation.di.getReservationFeatureModule
import com.mgacreative.hotelru.feature.room.di.getRoomFeatureModule
import com.mgacreative.hotelru.feature.reports.di.getReportsFeatureModule
import com.mgacreative.hotelru.feature.staff.di.getStaffFeatureModule
import com.mgacreative.hotelru.feature.housekeeping.di.getHousekeepingFeatureModule
import com.mgacreative.hotelru.feature.finance.di.getFinanceFeatureModule
import com.mgacreative.hotelru.feature.inventory.di.getInventoryFeatureModule
import com.mgacreative.hotelru.feature.maintenance.di.getMaintenanceFeatureModule
import com.mgacreative.hotelru.feature.pricing.di.getPricingFeatureModule
import com.mgacreative.hotelru.feature.restaurant.di.getRestaurantFeatureModule
import com.mgacreative.hotelru.feature.channelmanager.di.getChannelManagerFeatureModule
import com.mgacreative.hotelru.feature.ai_assistant.di.getAiAssistantFeatureModule
import com.mgacreative.hotelru.feature.crm.di.getCrmFeatureModule
import com.mgacreative.hotelru.feature.guestapp.di.getGuestAppFeatureModule

val webModule = module {
    // Web platformu icin boş PDF servisi saglıyoruz
    single<com.mgacreative.hotelru.feature.inventory.export.PdfExporter> {
        object : com.mgacreative.hotelru.feature.inventory.export.PdfExporter {
            override fun exportSupplierOrdersToPdf(
                supplierName: String,
                orders: List<com.mgacreative.hotelru.domain.repository.PurchaseOrder>,
                items: List<com.mgacreative.hotelru.domain.repository.PurchaseOrderItem>
            ) {
                // Web'de desteklenmiyor
            }
        }
    }
}

fun getWebAppModules(): List<Module> = listOf(
    getCommonAppModule(),
    getDomainModule(),
    getAdminFeatureModule(),
    getHotelFeatureModule(),
    getReservationFeatureModule(),
    getRoomFeatureModule(),
    getReportsFeatureModule(),
    getStaffFeatureModule(),
    getHousekeepingFeatureModule(),
    getFinanceFeatureModule(),
    getInventoryFeatureModule(),
    getMaintenanceFeatureModule(),
    getPricingFeatureModule(),
    getRestaurantFeatureModule(),
    getChannelManagerFeatureModule(),
    getAiAssistantFeatureModule(),
    getCrmFeatureModule(),
    getGuestAppFeatureModule(),
    webModule
)

